import styled from "styled-components";

export type AllyTab = 'profile' | 'reservations'

export default function Sidebar({ tab, setTab }: { tab: AllyTab, setTab: (tab: AllyTab) => void }) {
    return (
        <Main>
            <div>
                <h3
                onClick={() => setTab('profile')}
                className={tab === 'profile' ? 'active' : ''}
                >
                    Profile
                </h3>
                <h3
                onClick={() => setTab('reservations')}
                className={tab === 'reservations' ? 'active' : ''}
                >
                    Mis reservas
                </h3>
            </div>
        </Main>
    )
}

const Main = styled.aside`
> div {
    margin: 20px auto;
    width: fit-content;
    h3 {
        font-size: 16px;
        margin-bottom: 10px;
        font-weight: 400;
        color: ${props => props.theme.gray};
        cursor: pointer;
        transition: color .2s ease;
        &.active {
            color: #000;
        }
    }
}
`
